import React from 'react';

import { frontendUrl } from '../../config/urls';

const PrivacyPolicy = () => {
  return (
    <div className="legal privacy-policy">
      <h1>Privacy Policy</h1>
      <p>Updated: May 2019</p>
      <p>
        Hire Lambda makes available services, including our web site{' '}
        <a href={frontendUrl}>{frontendUrl}</a> and any other software, sites, and
        services offered by Hire Lambda in connection to any of those (taken
        together, the "Service"). It is Hire Lambda's policy to respect your
        privacy regarding any information we may collect while operating our
        websites.
      </p>

      <h2>Contact</h2>
      <p>
        If you have question about this Privacy Policy, please contact us at{' '}
        <a href="mailto:hirelambda@gmail.com">hirelambda@gmail.com</a>.
      </p>
      <h2>Visitors</h2>
      <p>
        The Service collects non-personally-identifying information of the sort
        that web browsers and servers typically make available, such as the
        browser type, language preference, referring site, and the date and time
        of each visitor request. The Service's purpose in collecting
        non-personally identifying information is to better understand how the
        Service's visitors use its website. From time to time, the Service may
        release non-personally-identifying information in the aggregate, e.g.,
        by publishing a report on trends in the usage of its website.
      </p>
      <p>
        The Service also collects potentially personally-identifying information
        like Internet Protocol (IP) addresses. Cadence does not use such
        information to identify its visitors, however, and does not disclose
        such information, other than under the same circumstances that it uses
        and discloses personally-identifying information, as described below. We
        may also collect and use IP addresses to block users who violated our
        Terms of Service.
      </p>

      <h2>Gathering of Personally-Identifying Information</h2>
      <p>
        Certain visitors to the Service choose to interact with the Service in
        ways that require the Service to gather personally-identifying
        information. The amount and type of information the Service gathers
        depends on the nature of the interaction. The Service collects such
        information only insofar as is necessary or appropriate to fulfill the
        purpose of the visitor's interaction with the Service. The Service does
        not disclose personally-identifying information other than as described
        below. And visitors can always refuse to supply personally-identifying
        information, with the caveat that it may prevent them from engaging in
        certain Service-related activities. Additionally, some interactions,
        such as adding a link to a user's profile or account on a social media
        site, may ask for optional personal information. Supplying such personal
        information is completely optional.
      </p>

      <h2>Public Information</h2>
      <p>
        The nature of the Service is primarily to create public profiles and to
        allow the public to access those profiles. Users who create profiles
        acknowledge the information in their profile will be made public, and
        they can remove specific information or delete their entire account. The
        Service will not rent or sell potentially personally-identifying and
        personally-identifying information to anyone.
      </p>
      <h2>Cookies</h2>
      <p>
        A cookie is a string of information that a website stores on a visitor's
        computer, and that the visitor's browser provides to the Service each
        time the visitor returns. The Service may use cookies to help the
        Service identify and track visitors, their usage of the Service, and
        their Service access preferences. Visitors who do not wish to have
        cookies placed on their computers should set their browsers to refuse
        cookies before using the Service's websites, with the drawback that
        certain features of may not function properly without the aid of
        cookies.
      </p>
      <h2>Data Storage</h2>
      <p>
        The Service uses third-party vendors and hosting partners to provide the
        necessary hardware, software, networking, storage, and related
        technology required to run the Service. You understand that although you
        retain full rights to your data, it may be stored on third-party storage
        and transmitted through third-party networks.
      </p>
      <h2>Privacy Policy Changes</h2>
      <p>
        The Service may change its Privacy Policy from time to time, and in the
        Service's sole discretion. The Service encourages visitors to frequently
        check this page for any changes to its Privacy Policy. Your continued
        use of this site after any change in this Privacy Policy will constitute
        your acceptance of such change.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
